import script from "./DashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardView.vue?vue&type=script&setup=true&lang=js"

import "./DashboardView.vue?vue&type=style&index=0&id=f11ac2b6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f11ac2b6"]])

export default __exports__